var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Links")]),_c('section',_vm._l((_vm.links),function(link){return _c('Link',{key:link.name,attrs:{"link":link}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }